var _g, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmaments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_119)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1004_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.18 335.91C258.548 353.635 267.917 371.36 279.026 387.343C300.595 419.358 325.741 446.593 352.572 459.497C365.687 465.649 380.083 467.509 394.808 464.825C407.585 462.283 420.74 454.547 434.178 442.916L434.78 443.518L435.128 443.169L437.913 440.384L438.262 440.036L441.743 436.554L441.442 436.253C452.678 423.813 459.765 410.705 462.308 397.928C464.944 383.852 462.387 370.153 456.236 357.038C443.934 330.808 417.997 305.568 387.281 283.905C370.695 272.193 352.764 261.226 334.437 251.255L249.481 336.211L249.18 335.91Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.907 119.55L183.563 158.894L199.579 200.676L158.145 184.312L118.801 223.656L118.406 224.654C116.665 226.394 117.125 228.944 118.63 230.449L168 279.819C168.903 280.722 170.804 281.23 172.497 280.138L216.147 265.99C224.076 285.756 233.255 306.078 243.639 327.604L325.462 245.781C305.282 234.654 283.963 225.869 265.194 217.545C265.89 216.849 265.241 216.896 265.937 216.2C265.937 216.2 277.761 177.885 279.737 172.898C280.18 171.252 279.625 170 278.722 169.097L229.051 119.427C227.546 117.922 224.648 117.809 222.907 119.55Z",
    fill: "#FCFCFC"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white",
    transform: "translate(94 94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1004_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.523,
    height: 378.897,
    fill: "white",
    transform: "translate(112.882 229.575) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmaments);
export default __webpack_public_path__ + "static/media/armaments.39d825caf9adb3c4b2f3b68ecee5a652.svg";
export { ForwardRef as ReactComponent };